import React, { FC } from 'react'

import { IconRafflesProps } from './IconRaffles.types'
import * as Styled from './styles/IconRaffles.style'

import { nonThemeableRules } from '../../ruleSet'

const IconRaffles: FC<IconRafflesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconRafflesProps['size'],
  isResponsive = false,
}: IconRafflesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M26.878 22.933S43.75 25 37 41' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='m21.122 20.832-3.89-2.192a11 11 0 0 1-3.107-2.95c-1.54-2.217-1.787-4.405-.643-6.162.736-1.13 1.908-1.473 3.126-1.096a1.445 1.445 0 0 0 1.774-.83c.5-1.177 1.5-1.857 2.845-1.697 2.078.25 3.59 1.848 4.296 4.455.362 1.398.447 2.854.25 4.285l-.825 4.398m-3.826 1.79L16.75 20a10.984 10.984 0 0 0-4.273.25c-2.6.708-4.192 2.223-4.442 4.308-.16 1.34.518 2.36 1.693 2.852a1.455 1.455 0 0 1 .827 1.783c-.377 1.217-.035 2.392 1.093 3.132 1.75 1.148 3.932.9 6.145-.645a10.967 10.967 0 0 0 2.942-3.117l2.185-3.9m.127.06-.825 4.397a11.045 11.045 0 0 0 .25 4.285c.705 2.608 2.218 4.205 4.295 4.455 1.338.16 2.353-.52 2.846-1.697a1.445 1.445 0 0 1 1.774-.83c1.218.38 2.39.035 3.126-1.095 1.145-1.75.897-3.945-.643-6.163a11.002 11.002 0 0 0-3.107-2.95l-3.89-2.192m.005 0 4.384.817c1.427.199 2.88.114 4.273-.25 2.6-.707 4.193-2.223 4.443-4.308.16-1.34-.518-2.36-1.693-2.852a1.452 1.452 0 0 1-.827-1.78c.377-1.22.035-2.395-1.093-3.133-1.75-1.15-3.933-.9-6.145.643a11.002 11.002 0 0 0-2.942 3.117l-2.185 3.903'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconRaffles
